export default __webpack_public_path__ + "static/media/crm.1ecbfc40.svg";